<script setup lang="ts">
import { computed } from 'vue'
import Chip from '@uiKit/elements/Chip.vue'
import type { ChipSize } from '@uiKit/elements/Chip.vue'
import { propertyStatusMetaOf, type PropertyPayoutFacts } from '../../constants/propertyLifecycle'

// Status pill for a property: its coarse lifecycle stage, or past funding, where
// the payout stands — the same label the detail screen's header shows.
const props = withDefaults(defineProps<{ property: PropertyPayoutFacts; size?: ChipSize }>(), {
  size: 'medium',
})

const meta = computed(() => propertyStatusMetaOf(props.property))
</script>

<template>
  <Chip :label="meta.label" :color="meta.color" :size="size" />
</template>
